if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".product-count")?.classList.remove("hidden");
        const config = fetchConfig("javascript");
        let variantId = this.querySelector(".product-variant-id").value;
        let quantity = document.querySelector("quantity-input input").value;
        console.log(variantId, quantity, "quantity");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append("id", variantId);
          formData.append("quantity", quantity);
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response, "response");
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              // Show error message on product form
              this.handleErrorMessage(response.description);

              // Remove loading states
              this.submitButton.classList.remove("loading");
              this.submitButton.removeAttribute("aria-disabled");

              // Optionally show sold-out message
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (soldOutMessage) {
                this.submitButtonText.classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
              }

              // Fetch the updated cart to reflect changes
              fetch("/cart.json")
                .then((res) => res.json())
                .then((cartData) => {
                  // Update cart total count
                  const cartCount = cartData.item_count || 0;
                  const cartTotalCountEl =
                    document.querySelector(".cart-total-count");
                  if (cartTotalCountEl) {
                    cartTotalCountEl.innerHTML = cartCount;
                  }

                  // Re-render mini cart if using cart drawer
                  if (
                    this.cart &&
                    typeof this.cart.renderContents === "function"
                  ) {
                    fetch(`${window.location.pathname}?sections=cart-drawer`)
                      .then((res) => res.json())
                      .then((sections) => {
                        this.cart.renderContents({
                          sections,
                          sections_url: window.location.pathname,
                        });
                      });
                  }

                  // Optionally open cart drawer
                  const cartDrawer = document.querySelector("cart-drawer");
                  if (cartDrawer) {
                    cartDrawer.classList.add("is-open");
                  }
                })
                .catch((err) => {
                  this.submitButton.classList.remove("loading");
                      this.querySelector(".product-count")?.classList.add(
                        "hidden"
                      );
                  console.error("Failed to refresh cart after error", err);
                });

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              if (document.querySelector(".main-product-upsell")) {
                document
                  .querySelector(".upsell-products__wrapper")
                  .classList.add("active");
                let upsellProducts = document.querySelector(
                  ".main-product-upsell"
                ).innerHTML;
                document.querySelector("product-upsell").innerHTML =
                  upsellProducts;
                document
                  .querySelector("product-upsell")
                  .classList.remove("hidden");
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.error) {
              console.log("Skipping upsell because of cart error");
              this.submitButton.classList.remove("loading");
               this.querySelector(".product-count")?.classList.add(
                        "hidden"
                      );
              return;
            }
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            let productId =
              document.querySelector("product-info").dataset.productId;
            let quantity =
              document.querySelector("[data-total-count]").dataset.totalCount;
            document.querySelector(".cart-total-count").innerHTML = quantity;
            fetch(
              window.Shopify.routes.root +
                `recommendations/products.json?product_id=${productId}&limit=3&intent=related`
            )
              .then((response) => response.json())
              .then(({ products }) => {
                if (products.length > 0) {
                  fetch("/cart.json")
                    .then((response) => response.json())
                    .then((data) => {
                      console.log(data, "data");
                      let filterProducts = [];
                      data.items.forEach((item) => {
                        filterProducts = products.filter(
                          (element) => element.id !== item.product_id
                        );
                      });
                      let Upsellproducts = "";
                      console.log(products, "products");
                      console.log(filterProducts, "filterProducts");
                      filterProducts.forEach((product) => {
                        Upsellproducts += `<div
                          class="flex flex-col items-center justify-center gap-4 upsell-product__item">
                          <a href="${product.url}" class="rerender_image overflow-hidden flex items-center justify-center bg-white border-2 border-black rounded-lg item-image shadow-btn-shadow shadow-hover_none">
                          
                          </a>
                          <a
                            href="${product.url}"
                            type="button"
                            class="text-sm text-center link-item link-black hidden">
                            Buy Now
                          </a>
                        </div>`;
                      });
                      // HOTFIX ATC BUG
                      // document.querySelector('.upsell-products-wrapper').innerHTML = Upsellproducts;
                      const upsellWrapper = document.querySelector(
                        ".upsell-products-wrapper"
                      );
                      if (upsellWrapper) {
                        upsellWrapper.innerHTML = Upsellproducts;
                      } else {
                        console.warn(
                          "No .upsell-products-wrapper found on this page."
                        );
                      }

                      filterProducts.forEach((product, index) => {
                        const img = document.createElement("img");
                        // Set the source and alt attributes
                        let imageUrl = `${product.featured_image}?&width=250&height=250`;
                        img.src = imageUrl;
                        img.alt = product.featured_image.alt;
                        // Optionally set other attributes, like width and height
                        document
                          .querySelectorAll(".rerender_image")
                          [index].appendChild(img);
                      });
                      document
                        .querySelector("product-upsell")
                        .classList.remove("hidden");
                      document
                        .querySelector(".upsell-products__wrapper")
                        .classList.add("active");
                      this.querySelector(".product-count")?.classList.add(
                        "hidden"
                      );
                    });
                }
              });
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
